import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/opt/build/repo/src/app/auth/login/login-form.tsx");
